import request from './request'

export function getOAuth2RedirectUrl(data) {
  return request({
    url: '/checkin/getOAuth2RedirectUrl',
    method: 'post',
    data
  })
}

export function getDepartmentList(data) {
  return request({
    url: '/checkin/getDepartmentList',
    method: 'post',
    data
  })
}

export function getConfigData(data) {
  return request({
    url: '/checkin/getConfigData',
    method: 'post',
    data
  })
}

export function apply(data) {
  return request({
    url: '/checkin/apply',
    method: 'post',
    data
  })
}

export function adminLogin(data) {
  return request({
    url: '/checkin/adminLogin',
    method: 'post',
    data
  })
}

export function scan(data) {
  return request({
    url: '/checkin/scan',
    method: 'post',
    data
  })
}

